export const AU_STATES = ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT", "Norfolk Island", "Overseas"];

export const ROLE_LABELS = { admin: "Admin", payroll_officer: "Payroll officer", read_only: "Read only" };

export const STATUS_LABELS = {
  new_join: "New join",
  onboarding: "Onboarding",
  ready_for_payroll: "Ready for payroll",
  active: "Active",
  active_not_paid: "Active not paid",
  inactive: "Inactive",
};

export const STATUS_STYLES = {
  new_join: "bg-sky-50 text-sky-700 border-sky-200",
  onboarding: "bg-amber-50 text-amber-700 border-amber-200",
  ready_for_payroll: "bg-violet-50 text-violet-700 border-violet-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  active_not_paid: "bg-orange-50 text-orange-700 border-orange-200",
  inactive: "bg-slate-100 text-slate-600 border-slate-200",
};

export const opts = (obj) => Object.entries(obj).map(([value, label]) => ({ value, label }));

export const PAY_SCHEDULES = {
  weekly: "Weekly", weekly_in_arrears: "Weekly in arrears", fortnightly_1: "Fortnightly 1", fortnightly_1_in_arrears: "Fortnightly 1 in arrears",
  fortnightly_2: "Fortnightly 2", fortnightly_2_in_arrears: "Fortnightly 2 in arrears", bi_monthly: "Bi-monthly", bi_monthly_in_arrears: "Bi-monthly in arrears",
  monthly: "Monthly", monthly_in_arrears: "Monthly in arrears", monthly_pwwgp: "Monthly (paid when we get paid)", yearly: "Yearly",
};
export const PAYMENT_TERMS = { "5_days": "5 days", "7_days": "7 days", "14_days": "14 days", "30_days": "30 days", paid_when_we_get_paid: "Paid when we get paid", other: "Other" };
export const CYCLES = { weekly: "Weekly", fortnightly: "Fortnightly", monthly: "Monthly" };
export const FEE_PAID_BY = { contractor: "Contractor", contractor_and_recruiter: "Contractor and recruiter", recruitment_company: "Recruitment company" };
export const ENTITIES = { payme_australia: "PayMe Australia", pte_company: "PTE company" };
export const MAX_HOURS_PER = { day: "Per day", week: "Per week", contract: "Per contract" };
export const RATE_TYPES = { hourly: "Hourly", daily: "Daily", weekly: "Weekly", monthly: "Monthly" };
export const EMPLOYEE_TYPES = { permanent: "Permanent", permanent_part_time: "Permanent part-time", casual: "Casual", contractor: "Contractor" };
export const DEACTIVATION_REASONS = {
  changed_recruitment_company: "Changed recruitment company", contract_not_renewed: "Contract not renewed", cheaper_payroll_company: "Cheaper payroll company",
  service_level: "Service level", no_longer_required: "No longer required", no_response: "No response",
};
